const PROTECTED_TOKEN_PREFIX = "\uE000premierelens-protected-";
const PROTECTED_TOKEN_SUFFIX = "\uE001";

const REPLACEMENTS = [
  [/\bA high[- ]stakes\b/g, "An intense"],
  [/\ba high[- ]stakes\b/g, "an intense"],
  [/\bthe stakes turn personal\b/gi, "the pressure becomes personal"],
  [/\bthe stakes become personal\b/gi, "the pressure becomes personal"],
  [/\bthe stakes are high\b/gi, "the pressure is intense"],
  [/\bthe stakes are low\b/gi, "the pressure is light"],
  [/\braises the stakes\b/gi, "increases the pressure"],
  [/\braised the stakes\b/gi, "increased the pressure"],
  [/\braising the stakes\b/gi, "increasing the pressure"],
  [/\braise the stakes\b/gi, "increase the pressure"],
  [/\bstakes keep rising\b/gi, "pressure keeps building"],
  [/\bstakes are rising\b/gi, "pressure is building"],
  [/\bstakes rise\b/gi, "pressure builds"],
  [/\bstakes climb\b/gi, "pressure builds"],
  [/\bstakes build\b/gi, "pressure builds"],
  [/\bstakes escalate\b/gi, "danger escalates"],
  [/\bstakes accumulate\b/gi, "pressure accumulates"],
  [/\bstakes level\b/gi, "danger level"],
  [/\blife[- ]or[- ]death stakes\b/gi, "life-or-death danger"],
  [/\bnational[- ]security stakes\b/gi, "national-security danger"],
  [/\bhigh[- ]casualty stakes\b/gi, "high-casualty danger"],
  [/\breal[- ]money stakes\b/gi, "real-money risk"],
  [/\bhigh[- ]stakes\b/gi, "intense"],
  [/\blow[- ]stakes\b/gi, "gentle"],
  [/\bhigher stakes\b/gi, "greater danger"],
  [/\bescalating stakes\b/gi, "rising danger"],
  [/\bemotional stakes are\b/gi, "emotional weight is"],
  [/\bemotional stakes stay\b/gi, "emotional weight stays"],
  [/\bemotional stakes feel\b/gi, "emotional weight feels"],
  [/\bromantic stakes are\b/gi, "romantic tension is"],
  [/\bromantic stakes stay\b/gi, "romantic tension stays"],
  [/\bemotional stakes\b/gi, "emotional weight"],
  [/\bromantic stakes\b/gi, "romantic tension"],
  [/\bpersonal stakes\b/gi, "personal consequences"],
  [/\bfamily stakes\b/gi, "family consequences"],
  [/\bcommunity stakes\b/gi, "consequences for the community"],
  [/\bcareer stakes\b/gi, "career consequences"],
  [/\bprofessional stakes\b/gi, "professional consequences"],
  [/\bfinancial stakes\b/gi, "financial consequences"],
  [/\bpolitical stakes\b/gi, "political consequences"],
  [/\bsurvival stakes\b/gi, "survival danger"],
  [/\bglobal stakes\b/gi, "global danger"],
  [/\bplanetary stakes\b/gi, "planetary danger"],
  [/\bcivilizational stakes\b/gi, "civilizational danger"],
  [/\bcriminal stakes\b/gi, "criminal consequences"],
  [/\bdramatic stakes\b/gi, "dramatic pressure"],
  [/\breal stakes\b/gi, "real consequences"],
  [/\bgenuine stakes\b/gi, "genuine consequences"],
  [/\bactual stakes\b/gi, "actual consequences"],
  [/\bstakes\b/gi, "consequences"],
];

function matchReplacementCase(source, replacement) {
  if (source === source.toUpperCase() && /[A-Z]/.test(source)) {
    return replacement.toUpperCase();
  }
  if (/^[A-Z]/.test(source)) {
    return replacement.replace(/^\w/, (character) => character.toUpperCase());
  }
  return replacement;
}

function protectPhrases(value, protectedPhrases = []) {
  let text = value;
  const protectedValues = [];

  for (const phrase of protectedPhrases) {
    if (typeof phrase !== "string" || !phrase || !/\bstakes\b/i.test(phrase)) {
      continue;
    }
    const token = `${PROTECTED_TOKEN_PREFIX}${protectedValues.length}${PROTECTED_TOKEN_SUFFIX}`;
    protectedValues.push(phrase);
    text = text.split(phrase).join(token);
  }

  return { text, protectedValues };
}

function restorePhrases(value, protectedValues = []) {
  return protectedValues.reduce(
    (text, phrase, index) => text.split(`${PROTECTED_TOKEN_PREFIX}${index}${PROTECTED_TOKEN_SUFFIX}`).join(phrase),
    value
  );
}

export function containsViewerFacingStakes(value, { protectedPhrases = [] } = {}) {
  if (typeof value !== "string" || !value) {
    return false;
  }
  const protectedCopy = protectPhrases(value, protectedPhrases);
  return /\bstakes\b/i.test(protectedCopy.text);
}

export function cleanViewerFacingCopy(value, { protectedPhrases = [] } = {}) {
  if (typeof value !== "string" || !/\bstakes\b/i.test(value)) {
    return value;
  }

  const protectedCopy = protectPhrases(value, protectedPhrases);
  let cleaned = protectedCopy.text;
  for (const [pattern, replacement] of REPLACEMENTS) {
    cleaned = cleaned.replace(pattern, (match) => matchReplacementCase(match, replacement));
  }
  return restorePhrases(cleaned, protectedCopy.protectedValues);
}

export function cleanViewerFacingCopyList(values, options = {}) {
  return Array.isArray(values)
    ? values.map((value) => cleanViewerFacingCopy(value, options))
    : [];
}
